import { ListenableEvent } from "./ListenableEvent";
var Log = /** @class */ (function () {
    function Log() {
    }
    Log.debug = function (pMsg) {
        console.log(Log.FormatMsg(pMsg));
    };
    Log.info = function (pMsg) {
        console.info(Log.FormatMsg(pMsg));
    };
    Log.warn = function (pMsg) {
        Log.eventWarn.trigger(pMsg);
        console.warn(Log.FormatMsg(pMsg));
    };
    Log.error = function (pMsg, pError) {
        Log.eventError.trigger({ message: pMsg, error: pError });
        var tMsg = Log.FormatMsg(pMsg);
        if (pError != null) {
            tMsg += " ";
            if (pError instanceof Error) {
                tMsg += pError;
                if (pError.stack != null)
                    tMsg += " Stack: " + pError.stack;
            }
            else
                tMsg += "Error: " + pError;
        }
        console.error(tMsg);
    };
    //// private ///////////////////////////////////////////////////////////////////////////////
    Log.FormatMsg = function (pMsg) {
        var tDate = new Date();
        var tTimeStr = tDate.getHours() + ":" + tDate.getMinutes() + ":" + tDate.getSeconds() + ":" + tDate.getMilliseconds();
        return ("[W-CF " + tTimeStr + "] " + pMsg);
    };
    Log.eventWarn = new ListenableEvent(null);
    Log.eventError = new ListenableEvent(null);
    return Log;
}());
export { Log };
export default Log;
